
import { AppService } from "app/services/app.service";
export abstract class AbConfigDispositivo extends AppService {
  abstract getConfigDispositivo(dispositivoId: number);
  abstract salvar(entity: any);
}